var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper"},[_c('ul',{staticClass:"nav-body"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:item.id,staticClass:"nav-item",class:{ active: item.active },on:{"mouseenter":function($event){return _vm.moveHandle(index)},"click":function($event){_vm.$router.push(
          {
            path: item.destination,
          },
          () => {}
        )}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }